import { ReactComponent as TickIcon } from "assets/icons/tick.svg";
import React, { useState } from "react";
import { Dropdown, Spinner } from "react-bootstrap";
import { DropDownItemType, DropDownWithAllProps } from "./DropDown.props";
import "./style.scss";

const DropDownWithAll = React.memo<DropDownWithAllProps>(
    ({
        data,
        title,
        type,
        className,
        getSelectedItem,
        allSelectionTitle,
        name,
    }) => {
        const [selectedItem, setSelectedItem] = useState(
            allSelectionTitle
                ? {
                      item: { title: allSelectionTitle },
                      id: 0,
                  }
                : null
        );

        const handleItemClick = (item: DropDownItemType, id: number) => {
            setSelectedItem({ item, id });
            getSelectedItem(item);
        };

        return (
            <Dropdown
                // @ts-ignore
                variant="Secondary"
                className={`${className} rtl dropdown-wrapper`}
            >
                <Dropdown.Toggle
                    id="dropdown-basic"
                    className="w-100 btn-secondary"
                >
                    {selectedItem ? (
                        <span>
                            {/* @ts-ignore */}
                            {selectedItem.item.title || selectedItem.item.name}
                        </span>
                    ) : (
                        <span> {title}</span>
                    )}
                </Dropdown.Toggle>

                <Dropdown.Menu className={`${type} w-100`}>
                    {allSelectionTitle && (
                        <Dropdown.Item
                            className={
                                selectedItem?.id === 0 ? `${type}-active` : ""
                            }
                            onClick={() =>
                                handleItemClick(
                                    { id: 0, title: allSelectionTitle },
                                    0
                                )
                            }
                        >
                            {allSelectionTitle}
                        </Dropdown.Item>
                    )}
                    {data ? (
                        data.map((item) => (
                            <Dropdown.Item
                                key={item.id}
                                onClick={() => handleItemClick(item, item.id)}
                                className={
                                    item.id === selectedItem?.id
                                        ? `${type}-active`
                                        : ""
                                }
                                data-testid="Dropdown__Item"
                            >
                                {type === "with-tick" && (
                                    <TickIcon className="tick-icon" />
                                )}
                                {item.name || item.title}
                            </Dropdown.Item>
                        ))
                    ) : (
                        <Dropdown.Item>
                            <Spinner animation="border" role="status" />
                        </Dropdown.Item>
                    )}
                </Dropdown.Menu>
            </Dropdown>
        );
    }
);

export default DropDownWithAll;
